import { FC } from "react";

import { Callout } from "src/components/Notifications";
import { useT } from "src/internationalization";

export type OutdatedCaseWarningProps = {
  onClick: () => void;
};

export const OutdatedCaseWarning: FC<OutdatedCaseWarningProps> = ({ onClick }) => {
  const t = useT();

  return (
    <Callout
      title={t("general.attention")}
      subtitle={t("caseVersions.outdated.warning.message")}
      actionButtonLabel={t("caseVersions.outdated.warning.button")}
      onActionButtonClick={onClick}
    />
  );
};

export const OutdatedAlertCaseWarning: FC<OutdatedCaseWarningProps> = ({ onClick }) => {
  const t = useT();

  return (
    <Callout
      title={t("general.attention")}
      subtitle={t("caseVersions.outdated.alert.warning.message")}
      actionButtonLabel={t("caseVersions.outdated.warning.button")}
      onActionButtonClick={onClick}
    />
  );
};
